module.exports = __webpack_public_path__ + "media/images/img-blacksmith-87aa010c5e673d1da4f98d27afb45349.svg";